import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// Components
import { Button, Dialog } from '@betareader/design-system';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  fetchConversations,
  fetchContacts,
  saveConversation,
  setCurrentConversation,
  closeConversation
} from '../../modules/message';
import { authUtil } from '../../utils';
import featureToggleUtil from '../../utils/featureToggleUtil';

import Avatar from '../../components/avatar/avatar';
import ConversationSettings from './conversationSettings';
import ReportOrBlockButton from './reportOrBlockButton';


export class ConversationHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conversationMemberModalOpen: false
    };
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (prevProps.match.params?.conversationId !== 'new' && match.params?.conversationId === 'new') {
      this.openConversationMemberModal();
    }
  }

  openConversationMemberModal = () => {
    this.setState({ conversationMemberModalOpen: true });
  }

  closeConversationMemberModal = () => {
    this.setState({ conversationMemberModalOpen: false });
  }

  handleSubjectChange = (event) => {
    const { currentConversation } = this.props;
    this.props.setCurrentConversation({
      ...currentConversation,
      subject: event.target.value,
      hasChanges: true
    });
  }

  handleSubjectKeyDown = (event) => {
    if (event.keyCode === 13) {
      // this is a CMD+Enter or Ctrl+Enter event. Submit reply
      this.saveSubject();
    }
  }

  saveSubject = () => {
    const { idToken, currentConversation, userProfile } = this.props;
    if (currentConversation._id && currentConversation.admins.includes(userProfile?._id)) {
      // this is an existing conversation, push the update
      this.props.saveConversation(idToken, { conversation: currentConversation });
    } else {
      // do nothing. the current subject will be used when starting the conversation
    }
  }

  closeConversation = async () => {
    const { currentConversation } = this.props;
    const idToken = await authUtil.getFreshIdToken();

    if (currentConversation && currentConversation._id) {
      const updateData = {
        closed: true
      };
      this.props.closeConversation(idToken, currentConversation._id, updateData);
    }
  }

  render() {
    const {
      t, currentConversation, userProfile
    } = this.props;
    const { conversationMemberModalOpen } = this.state;

    if (!currentConversation) {
      return null;
    }

    if (!userProfile) {
      return null;
    }

    const canEditConversation = currentConversation.admins.includes(userProfile._id);
    if (currentConversation) {
      return (
        <div style={{ marginLeft: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--br-space-2)' }}>
            <label className='br-field' htmlFor='conversation-subject' style={{ flex: 1 }}>
              <span className='br-field__label'>{t('NameConversation')}</span>
              <input id='conversation-subject' className='br-field__input'
                value={currentConversation.subject || ''}
                onChange={this.handleSubjectChange}
                onKeyUp={this.handleSubjectKeyDown}
                readOnly={!canEditConversation} />
            </label>
            {!currentConversation.isNew && currentConversation.hasChanges && canEditConversation && (
              <Button size='small' onClick={this.saveSubject}
                disabled={currentConversation.saving} aria-busy={currentConversation.saving}>
                {t('Save')}
              </Button>
            )}
          </div>
          <div style={{
            display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center',
            gap: 'var(--br-space-2)', marginTop: 'var(--br-space-2)'
          }}>
                { currentConversation.type && currentConversation.type === 'support'
                  ? [
                    <Avatar key='c_$userAvatar' name={userProfile.displayName} diameter={25} style={{ marginRight: 2 }} />,
                    <Avatar key='c_$supportAvatar' name='support' diameter={25} style={{ marginRight: 2 }} />
                  ]
                  : currentConversation.members.map((member, index) => {
                    if (member) {
                      return <Avatar key={`c_${index}${member._id}`} name={member.displayName} userId={member._id} diameter={25} style={{ marginRight: 2 }} />;
                    }
                    return null;
                  })
              }
                { currentConversation.type !== 'support'
                && ([
                  <Button key='buttonOpenConversationModal' variant='secondary' size='small'
                    onClick={this.openConversationMemberModal}>{t('Members')}</Button>,
                  <Dialog
                    key='conversationMemberModal'
                    open={conversationMemberModalOpen}
                    onClose={this.closeConversationMemberModal}
                    title={t('Members')}
                    actions={<Button variant='secondary' onClick={this.closeConversationMemberModal}>{t('Close')}</Button>}
                  ><ConversationSettings /></Dialog>
                ])}
                {currentConversation.type !== 'support' && (
                  <ReportOrBlockButton />
                )}
                { canEditConversation && featureToggleUtil.hasFeatureAccess(userProfile, 'closeConversations')
                && (
                  <Button
                    onClick={this.closeConversation}
                    variant='secondary'
                    className='chat-header-close-button'
                  >
                    {t('Close')}
                  </Button>
                )
                }
          </div>
        </div>
      );
    }
    return null;
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
  conversations: state.message.conversations,
  currentConversation: state.message.currentConversation,
  contacts: state.message.contacts
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchConversations,
  fetchContacts,
  saveConversation,
  setCurrentConversation,
  closeConversation,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationHeader)));
